"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListboxGroupLabel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ListboxOptionMedia = require("../ListboxOptionMedia/ListboxOptionMedia");
var _ListboxGroupLabel = require("./ListboxGroupLabel.styles");
var _excluded = ["label", "icon"];
/**
 * A group label for the `Listbox` component.
 *
 * **Note:** This component is not meant to be used outside the context of a
 * `Listbox` `renderGroupLabel` callback.
 *
 * @since 8.28.0
 */
var ListboxGroupLabel = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var label = _ref.label,
    icon = _ref.icon,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var mediaNode;
  if (icon) {
    mediaNode = /*#__PURE__*/_react.default.createElement(_ListboxOptionMedia.ListboxOptionMedia, null, icon);
  }
  return /*#__PURE__*/_react.default.createElement(_ListboxGroupLabel.StyledListboxGroupLabel, (0, _extends2.default)({
    ref: forwardedRef,
    icon: icon
  }, rest), mediaNode, label);
});
exports.ListboxGroupLabel = ListboxGroupLabel;
ListboxGroupLabel.displayName = 'ListboxGroupLabel';
ListboxGroupLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The label text.
   */
  label: _propTypes.default.string.isRequired,
  /**
   * An optional `Icon` for the label.
   */
  icon: _propTypes.default.node,
  /**
   * Labels are given a [presentation](https://www.w3.org/TR/wai-aria-1.2/#presentation) role by
   * default.
   */
  role: _propTypes.default.string,
  /**
   * All groups require a label, but in some cases we might want to visually hide the label.
   * Note: It only really makes sense to hide the first group label, otherwise separate groups
   * will be visually grouped together.
   */
  visuallyHidden: _propTypes.default.bool
} : {};
ListboxGroupLabel.defaultProps = {
  role: 'presentation'
};